import axios from "axios";
import weChatAuth from "../wechat/weChatAuth";
import { Y_TOKEN } from "../utils/Var";

const instance = axios.create({
    timeout: 10000,
    baseURL: (process.env.VUE_APP_API_LINK || "https://wechat.test.tuzuu.com") + "/api/v1",
});

// 请求拦截器
instance.interceptors.request.use(request => {
    const token = localStorage.getItem(Y_TOKEN);

    if (token){
        request.headers.Authorization = 'Bearer ' + token;
    } 
	
    return request;
}, err => {
    return Promise.reject(err)
})

// 响应拦截器
instance.interceptors.response.use(res => {
    if (res.status === 200) {
        if (res.data.code == 401){
            localStorage.removeItem(Y_TOKEN);
            weChatAuth().then(() => {
                location.reload();
            });
        }
        return res.data;
    }
    return res;
}, err => {
    return Promise.reject(err);
});

export default instance;